"use client";

import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface HamburgerButtonProps {
  isOpen: boolean;
  onClick: () => void;
  dark?: boolean;
}

export function HamburgerButton({
  isOpen,
  onClick,
  dark = false,
}: HamburgerButtonProps) {
  return (
    <button
      type="button"
      aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
      aria-expanded={isOpen}
      onClick={onClick}
      className={cn(
        "relative z-[60] flex h-10 w-10 items-center justify-center rounded-full",
        "transition-colors duration-300",
        dark
          ? "text-black hover:bg-black/10"
          : "text-paper hover:bg-white/10"
      )}
    >
      {isOpen ? (
        <X size={20} strokeWidth={1.8} />
      ) : (
        <Menu size={20} strokeWidth={1.8} />
      )}
    </button>
  );
}